import React, { useEffect, useState, useContext } from 'react';
import AdminSidebar from '../../../components/AdminSidebar/AdminSidebar';
import { AuthContext } from '../../../context/AuthContext';

// Opción B: permite apuntar a API remota con REACT_APP_API_BASE_URL en desarrollo
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '/api';

const AdminLogs = () => {
  const { authToken } = useContext(AuthContext);
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [viewMode, setViewMode] = useState('table'); // 'table' o 'cards'
  const [perPage, setPerPage] = useState(10);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState('');
  const [actionFilter, setActionFilter] = useState('all');

  useEffect(() => {
    const fetchLogs = async () => {
      setLoading(true);
      setError('');
      try {
        const response = await fetch(`${API_BASE_URL}/logs`, {
          headers: { 'Authorization': `Bearer ${authToken}` }
        });
        if (!response.ok) {
          const data = await response.json().catch(() => ({}));
          throw new Error(data.message || 'Error al cargar logs');
        }
        const data = await response.json();
        setLogs(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchLogs();
  }, [authToken]);

  // Filtrado
  const filteredLogs = logs.filter(log => {
    const matchesSearch =
      log.action.toLowerCase().includes(search.toLowerCase()) ||
      log.user.toLowerCase().includes(search.toLowerCase()) ||
      log.detail.toLowerCase().includes(search.toLowerCase());
    const matchesAction = actionFilter === 'all' ? true : log.action === actionFilter;
    return matchesSearch && matchesAction;
  });

  // Paginación
  const totalPages = Math.ceil(filteredLogs.length / perPage) || 1;
  const paginatedLogs = filteredLogs.slice((page - 1) * perPage, page * perPage);

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) setPage(newPage);
  };

  // Obtener acciones únicas para el filtro
  const uniqueActions = Array.from(new Set(logs.map(l => l.action))).filter(Boolean);

  return (
    <div className="admin-users-container">
      <AdminSidebar />
      <div className="admin-content">
        <h1 className="admin-page-title">Logs del Sistema</h1>
        <div style={{display:'flex',gap:16,alignItems:'center',marginBottom:16,flexWrap:'wrap'}}>
          <label style={{fontWeight:500}}>Ver como:</label>
          <select value={viewMode} onChange={e => setViewMode(e.target.value)} style={{padding:4}}>
            <option value="table">Tabla</option>
            <option value="cards">Tarjetas</option>
          </select>
          <label style={{fontWeight:500}}>Mostrar:</label>
          <select value={perPage} onChange={e => {setPerPage(Number(e.target.value));setPage(1);}} style={{padding:4}}>
            <option value={5}>5</option>
            <option value={10}>10</option>
            <option value={20}>20</option>
            <option value={50}>50</option>
          </select>
          <input
            type="text"
            placeholder="Buscar por acción, usuario o detalle..."
            value={search}
            onChange={e => {setSearch(e.target.value); setPage(1);}}
            style={{padding:4,minWidth:180}}
          />
          <select value={actionFilter} onChange={e => {setActionFilter(e.target.value); setPage(1);}}
            style={{padding:4}}>
            <option value="all">Todas las acciones</option>
            {uniqueActions.map(action => (
              <option key={action} value={action}>{action}</option>
            ))}
          </select>
          <span style={{color:'#888',fontSize:'0.95rem'}}>Página {page} de {totalPages}</span>
        </div>
        {loading && (
          <div style={{display:'flex',flexDirection:'column',alignItems:'center',margin:'40px 0'}}>
            <div className="modern-spinner" />
            <span style={{color:'#888',fontWeight:500,fontSize:'1.1rem',marginTop:12}}>Cargando logs...</span>
          </div>
        )}
        {error && <p className="error-message">{error}</p>}
        {!loading && !error && filteredLogs.length === 0 && (
          <div style={{textAlign:'center',color:'#888',padding:'40px 0'}}>No hay logs registrados.</div>
        )}
        {!loading && !error && filteredLogs.length > 0 && viewMode === 'table' && (
          <div className="admin-section" style={{overflowX:'auto'}}>
            <table className="users-table">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Acción</th>
                  <th>Usuario</th>
                  <th>Fecha</th>
                  <th>Detalle</th>
                </tr>
              </thead>
              <tbody>
                {paginatedLogs.map(log => (
                  <tr key={log.id}>
                    <td>{log.id}</td>
                    <td>{log.action}</td>
                    <td>{log.user}</td>
                    <td>{new Date(log.timestamp).toLocaleString()}</td>
                    <td>{log.detail}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
        {!loading && !error && filteredLogs.length > 0 && viewMode === 'cards' && (
          <div style={{display:'flex',flexWrap:'wrap',gap:20,marginTop:16}}>
            {paginatedLogs.map(log => (
              <div key={log.id} style={{background:'#fff',borderRadius:10,boxShadow:'0 2px 8px 0 rgba(0,0,0,0.07)',padding:18,minWidth:260,maxWidth:340,flex:'1 1 260px',borderLeft:'5px solid #FFD700'}}>
                <div style={{fontWeight:700,fontSize:'1.05rem',marginBottom:6}}>{log.action}</div>
                <div style={{marginBottom:4}}><b>Usuario:</b> {log.user}</div>
                <div style={{marginBottom:4}}><b>Fecha:</b> {new Date(log.timestamp).toLocaleString()}</div>
                <div style={{marginBottom:4}}><b>Detalle:</b> {log.detail}</div>
                <div style={{color:'#bbb',fontSize:'0.9rem'}}>ID: {log.id}</div>
              </div>
            ))}
          </div>
        )}
        {/* Paginación */}
        {!loading && !error && filteredLogs.length > 0 && (
          <div style={{display:'flex',gap:8,justifyContent:'center',alignItems:'center',margin:'32px 0'}}>
            <button onClick={()=>handlePageChange(page-1)} disabled={page===1} style={{padding:'6px 14px',borderRadius:6,border:'1px solid #FFD700',background:page===1?'#eee':'#FFD700',color:page===1?'#aaa':'#222',fontWeight:600,cursor:page===1?'not-allowed':'pointer'}}>Anterior</button>
            <span style={{fontWeight:500}}>Página {page} de {totalPages}</span>
            <button onClick={()=>handlePageChange(page+1)} disabled={page===totalPages} style={{padding:'6px 14px',borderRadius:6,border:'1px solid #FFD700',background:page===totalPages?'#eee':'#FFD700',color:page===totalPages?'#aaa':'#222',fontWeight:600,cursor:page===totalPages?'not-allowed':'pointer'}}>Siguiente</button>
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminLogs;
